import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity, Clock, TrendingUp, Users } from "lucide-react";
import type { AnalyticsOverview } from "@/types/analytics.types";

interface AnalyticsOverviewCardsProps {
  overview: AnalyticsOverview;
}

export const AnalyticsOverviewCards = ({ overview }: AnalyticsOverviewCardsProps) => {
  const formatDuration = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Absprungrate</CardTitle>
          <TrendingUp className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{overview.bounceRate.toFixed(1)}%</div>
          <p className="text-xs text-muted-foreground">
            Besucher die nur eine Seite ansehen
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Ø Sitzungsdauer</CardTitle>
          <Clock className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{formatDuration(overview.avgSessionDuration)}</div>
          <p className="text-xs text-muted-foreground">
            Durchschnittliche Zeit pro Besuch
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Sitzungen</CardTitle>
          <Users className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{overview.totalSessions.toLocaleString()}</div>
          <p className="text-xs text-muted-foreground">
            Gesamte Besuche im Zeitraum
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Conversion Rate</CardTitle>
          <Activity className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{overview.conversionRate.toFixed(2)}%</div>
          <p className="text-xs text-muted-foreground">
            {overview.totalConversions} Conversions
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
